
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 32 32\" id=\"vimeo-alt\" ><defs/><title>vimeo-dk</title><g id=\"vimeo-alt_Layer_2\" data-name=\"Layer 2\"><path class=\"cls-1\" d=\"M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm7.92 12.37c-.89 5-5.89 9.3-7.39 10.28s-2.87-.39-3.37-1.42-2.28-7.55-2.72-8.08-1.79.53-1.79.53L8 12.82s2.72-3.25 4.79-3.66 2.19 3.37 2.72 5.48.85 3.21 1.3 3.21S18.11 16.71 19 15s0-3.29-1.87-2.19c.78-4.42 7.68-5.47 6.79-.44z\" id=\"vimeo-alt_Icons\"/></g></symbol>";
module.exports = sprite.add(image, "vimeo-alt");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/vimeo-alt.svg
// module id = 669
// module chunks = 1474